import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Snackbar,
  Alert,
  CircularProgress,
} from '@mui/material';
import { PaymentAPIService } from '../../services/api';
import { API_ERROR_MESSAGE, API_SUCCESS_MESSAGE } from '../../shared/constants';

const UserPaymentUnsubscribe = ({ open, onClose, phone,payment_customer_id }) => {
  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackData, setSnackData] = useState({
    show: false,
    message: "",
    type: "error",
  });

  const handleUnsubscribe = async () => {
    setLoading(true);

        let payload = {
            payment_customer_id:payment_customer_id,
            phone:phone,
            status:"unsubscribed"
        }
      PaymentAPIService.unsubscribe(payload)
           .then((response) => {
             setSnackData({
               show: true,
               message: response.message || API_SUCCESS_MESSAGE.UNSUBSCRIBED_SUCCESSFULLY,
               type: "success",
             });

             onClose();
           })
           .catch((errResponse) => {
             setSnackData({
               show: true,
               message:
                 errResponse?.response?.data?.message ||
                 API_ERROR_MESSAGE.INTERNAL_SERVER_ERROR,
               type: "error",
             });
             onClose();
           })
           .finally(() => setLoading(false));
  };

  return (
    <>
      <Dialog open={open} onClose={onClose}>
        <DialogTitle>Unsubscribe User</DialogTitle>
        <DialogContent>
          Are you sure you want to unsubscribe this user?
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} disabled={loading}>No</Button>
          <Button
            onClick={handleUnsubscribe}
            color="error"
            variant="contained"
            disabled={loading}
          >
            {loading ? <CircularProgress size={20} color="inherit" /> : 'Yes'}
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        style={{ top: "80px" }}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={snackData.show}
        autoHideDuration={3000}
        onClose={() => setSnackData({ show: false })}
      >
        <Alert
          onClose={() => setSnackData({ show: false })}
          severity={snackData.type}
        >
          {snackData.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default UserPaymentUnsubscribe;
